<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        small
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="font-weight-bold">
        {{ payrollTransactionDetail.company_employee.employee.person.name }}'s {{ payrollTransactionDetail.deduction_or_earning.name }}
      </v-card-text> 

      <v-card-text class="pt-0">
        <v-text-field
          v-model="localPayrollTransactionDetail.amount"
          v-validate="'required|twoDecimalValue'" 
          label="Amount"
          :error-messages="errors.collect('amount')"
          data-vv-name="amount"    
          data-vv-as="amount" 
          prefix="RM"
        />
      </v-card-text>

      <v-card-text
        v-if="payrollTransactionDetail.is_fixed_doe"
        class="pt-0"
      >
        <v-textarea
          v-model="payrollTransactionDetail.remark"
          v-validate="'required|max:255'"
          counter
          :error-messages="errors.collect('remark')"
          data-vv-name="remark"      
          label="Remark"
          rows="3"
          fillable
          auto-grow
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          class="white--text"
          color="hrissecondary"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  import Big from 'big.js'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollTransactionDetail: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        remark: null,
        localPayrollTransactionDetail: {
          amount: 0,
        },
      }
    },

    watch: {
      menu: function (value) {
        this.localPayrollTransactionDetail = { ...this.payrollTransactionDetail }

        let _this = this

        if (this.localPayrollTransactionDetail.amount) { this.localPayrollTransactionDetail.amount = (Math.round((this.localPayrollTransactionDetail.amount / 100) * 100) / 100).toFixed(2) }

        this.$validator.extend('twoDecimalValue', {
          getMessage (field, args) {
            return 'Only 2 Decimals are allowed'
          },
          validate (value, args) {
            return _this.isValidNumbers(value)
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.progressing = true

            this.$api.payrollTransactionDetails().update(this.payrollTransactionDetail.id, { remark: this.payrollTransactionDetail.remark, amount: this.localPayrollTransactionDetail.amount })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.menu = false
                }
              })
              .catch(error => {
                if (error.response.status >= 400 && error.response.status < 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      isValidNumbers (value) {
        return (new Big(value).times(10000) % 100 === 0)
      },
    },
  }
</script>
